import React, { Component } from 'react';
import ReactTable from 'react-table-6';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class BackendApiView extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({
        hideDialog: false,
        hideAddDialog: false,
        hideDeletePopup: false,
        hideDeleteAllPopup: false,
        hideIncorrectPassword: false,
        disabled: false
      });
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    }; this.IncorrectPassworddialogClose = () => {
      this.setState({ hideIncorrectPassword: false });
    };
    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchBackendApisOfTheProject()
        this.dialogClose();
      }
    }];
    //for add dialog component ok click
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchBackendApisOfTheProject()
        this.dialogClose();
        this.setState({
          disabled: false
        })

      }
    }];
    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': (props) => {
        this.deleteBackendApi(this.state.propsId)
      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.dialogInstance.hide();
        this.fetchBackendApisOfTheProject();

      }
    }];

    //deleteall
    this.deleteAllButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      }, 'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
          hideTextAreaPopup: true
        });
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
        });
      }
    }];

    //deleteall text confirmation
    this.textAreaConfir = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.deleteInputValidation()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideTextAreaPopup: false,
        });
      }
    }];
    //incorrectPasswordButtons
    this.incorrectPasswordButtons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.setState({
          hideTextAreaPopup: true,
          hideIncorrectPassword: false

        })
      }
    }];

    this.state = {
      data: [{
        id: '',
        name: '',
        url: '',
        userName: '',
        password: '',
        deleteRow: false,
        contentEditiable: "false"
      }],
      hideIncorrectPassword: false,
      hideTextAreaPopup: false,
      pageNum: null,
      disabled: false,
      fields: '',
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      showPwd: false,
      viewedId: '--1',
      hideDialog: false,
      hideAddDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      makeEditButtonAfterRefresh: '-1',
      successResp: false,
      hideDeleteAllPopup: false
    };
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.currentSrc = "";
    this.newRowId = "0";
    this.blindEyeSrc = "assets/images/blindEye.png";
    this.openEyeSrc = "assets/images/eye.png";
  }
  componentDidMount = () => {
    setTimeout(() => {
      this.fetchBackendApisOfTheProject();
    }, 300);
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {

      thisController.fetchBackendApisOfTheProject(event.projectId);
      thisController.projectId = event.projectId;
    });
  }
  markAsBeingEdited = (id) => {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);

  }
  deleteAllBackendApi = () => {
    let deleteApiViewController = this;
    $.ajax({
      url: "/api/task-api/delete-all",
      async: false,
      method: 'POST',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      data: {
        projectId: localStorage.getItem('currentProjectId')
      },
      success: function (res) {

        if (res.success === true && res.result === "done.") {
          deleteApiViewController.state.hideTextAreaPopup = false;
          deleteApiViewController.state.disableMultipleDelete = true;
          deleteApiViewController.state.checkBoxRows = [];
          deleteApiViewController.setState(deleteApiViewController.state);
          deleteApiViewController.fetchBackendApisOfTheProject();
          deleteApiViewController.notifyDeleteAllSuccess();
        } else if (res.success === true && res.result != "done.") {
          deleteApiViewController.notifyNodata(res.result);

        } else {
          deleteApiViewController.notifyFailedDelete(res.result);
        }
      },

      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }
  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });


  }


  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;All intents have been deleted Successfully</b>, {
      position: "top-center",
    });

  }
  notifyNodata(response) {
    this.setState({
      hideTextAreaPopup: false
    })
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });


  }
  deleteInputValidation = () => {
    if (document.getElementById('deleteInputFromUser').value == "Delete" ||
      document.getElementById('deleteInputFromUser').value == "delete" ||
      document.getElementById('deleteInputFromUser').value == "DELETE") {
      document.getElementById('deleteInputFromUser').value = "";
      this.deleteAllBackendApi();
    }
    else {
      this.setState({
        hideIncorrectPassword: true
      })
    }
  }

  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;All APIs have been deleted Successfully</b>, {
      position: "top-center",
    });

  }
  saveBackendApi(props, e) {

    this.state.editedId = "-1";
    props.original.name = document.getElementById("name" + props.index).innerText.trim();
    props.original.url = document.getElementById("url" + props.index).innerText.trim();
    props.original.userName = document.getElementById("userName" + props.index).innerText.trim();
    props.original.password = document.getElementById("password" + props.index).value.trim();
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.name, props.original.url,
      props.original.userName, props.original.password);
    if ((validateResult) == true) {
      var updatedData = {
        name: props.original.name,
        url: props.original.url,
        userName: props.original.userName,
        password: props.original.password,
        projectId: localStorage.getItem('currentProjectId')
      };
      var addBackendApiController = this;
      $.ajax({
        url: "/api/task-api",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            if (addBackendApiController.validateUrlCell(props.original.url) == false) {
              setTimeout(() => {
                addBackendApiController.notifyAdded();
                addBackendApiController.fetchBackendApisOfTheProject();
                addBackendApiController.setState({
                  disabled: false
                })
              }, 1000);
            } else {
              addBackendApiController.notifyAdded();
              addBackendApiController.fetchBackendApisOfTheProject();
              addBackendApiController.setState({
                disabled: false
              })
            }
          } else {
            addBackendApiController.notifyError(res.result);
          }
        },

        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
  }
  notifyAdded() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API Added Successfully</b>, {
      position: "top-center",

    });
  }


  notifyError(response) {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/warn.svg" style={{
        paddingRight: '0px',
        height: '20px', width: '20px'
      }} content="" />{response}</b>, {
      position: "top-center"
    });
  }


  updateBackendApi(props, e) {
    this.state.editedId = "-1";
    props.original.name = document.getElementById("name" + props.index).innerText.trim();
    props.original.url = document.getElementById("url" + props.index).innerText.trim();
    props.original.userName = document.getElementById("userName" + props.index).innerText.trim();
    props.original.password = document.getElementById("password" + props.index).value.trim();
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.name, props.original.url,
      props.original.userName, props.original.password);
    if ((validateResult) == true) {
      var updatedData = {
        name: props.original.name,
        url: props.original.url,
        userName: props.original.userName,
        password: props.original.password,
        id: props.original.id,
        projectId: localStorage.getItem("currentProjectId")
      };
      var updateBackendApiController = this
      $.ajax({
        url: "/api/task-api",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            if (updateBackendApiController.validateUrlCell(props.original.url) == false) {
              setTimeout(() => {
                updateBackendApiController.notifyUpdate();
                updateBackendApiController.fetchBackendApisOfTheProject();
              }, 1000)
            } else {
              updateBackendApiController.notifyUpdate();
              updateBackendApiController.fetchBackendApisOfTheProject();
            }
          } else {

            updateBackendApiController.notifyError(res.result);
          }
        },

        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
  }

  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API Updated Successfully</b>, {
      position: "top-center",

    });
  }

  deleteBackendApi = (id) => {
    var deleteConstructorVariables = this;
    $.ajax({
      url: "/api/task-api/" + id,
      async: false,
      method: 'DELETE',
      headers: {
        "Authorization": "Bearer " +
          localStorage.getItem("access_token")
      },

      success: function (res) {
        if (res.success === true) {
          deleteConstructorVariables.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteConstructorVariables.notifyDelete();
        } else {
          deleteConstructorVariables.notifyError(res.result);
        }
      },

      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchBackendApisOfTheProject();
  }


  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API Deleted Successfully</b>, {
      position: "top-center",

    });

  }

  editCell(props, e) {
    this.markAsBeingEdited(props.original.id);
  }

  fetchBackendApisOfTheProject = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    let backendApiViewController = this;
    $.ajax({
      url: "/api/task-api",
      async: false,
      method: 'GET',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      data: { projectId: projectId },
      success: function (res) {
        if (res.success === true) {
          backendApiViewController.setState({
            data: res.result,
            successResp: true,
            disabled: false
          });
        } else {
          backendApiViewController.notifyError(res.result);
        }
      },

      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }

  notifyFailedLoad() {
    toast(<b style={{ color: "#007aff" }}>Failed to Load</b>, {

      position: "bottom-center",
      color: "#007aff"
    });
  }
  addRow = (data) => {
    var rowController = this;
    if (rowController.state.pageNum != 0) {
      rowController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      name: '',
      url: '',
      userName: '',
      password: ''
    });
    this.setState({
      data: this.state.data,
      disabled: true
    })
  }
  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }
  showPassword = () => {
    if (this.state.showPwd) {
      this.setState({ showPwd: false });
    } else {
      this.setState({ showPwd: true });
    }

  }
  validateCells(name, url, userName, password) {
    if ((name == "" || userName == "" || password == "" || url == "")) {
      this.notifyEmptyFields();
      return false;
    } else {
      return true;
    }
  }
  validateUrlCell(url) {
    var pattern = new RegExp(/^((https):\/\/)/);
    if (!pattern.test(url)) {
      this.notifyInvalidUrlFiled();
      return false;
    }
    else {
      return true;
    }
  }
  notifyEmptyFields() {
    toast(<b>
      <img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all fields</b>, {
      position: "bottom-center",
      color: "#007aff"
    });
  }
  notifyInvalidUrlFiled() {
    toast(<b style={{ color: "rgb(40, 42, 101)" }}>
      <img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;A secured URL(Eg:https://dhee.ai) is needed</b>, {
      position: "bottom-center", color: "rgb(40, 42, 101)"


    });
  }

  viewClickedCell(props, e) {
    if (this.state.viewedId == props.original.id) {
      this.closeClickedCell(props, e)
      return
    }
    this.state.viewedId = props.original.id;
    props.original.name = document.getElementById("name" + props.index).innerText;
    props.original.url = document.getElementById("url" + props.index).innerText;
    props.original.userName = document.getElementById("userName" + props.index).innerText;
    props.original.password = document.getElementById("password" + props.index).value;
    this.setState(this.state);
  }
  closeClickedCell(props, e) {
    this.state.viewedId = '--1';
    this.setState(this.state);
  }
  onPasswordhandleChange(event, props) {

    props.original.password = event.target.value;
    this.setState(
      this.state);

  }
  onNamehandleChange(event, props) {

    props.original.name = document.getElementById("name" + props.index).innerText;
    this.setState(
      this.state);

  }
  onUrlhandleChange(event, props) {

    props.original.url = document.getElementById("url" + props.index).innerText;
    this.setState(
      this.state);

  }
  onUserNameHandleChange(event, props) {

    props.original.userName = document.getElementById("userName" + props.index).innerText;
    this.setState(
      this.state);

  }
  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.setState({ disabled: false })
    this.fetchBackendApisOfTheProject();
  }

  render() {
    const { data } = this.state;

    const columns = [
      {
        Header: <b>Url Name</b>,
        accessor: 'name',
        Cell: props => (<div
          Align="left" className="input"
          style={{
            padding: '8px', width: '98%', borderBottom: 'none',
            border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
              '1px solid #D2D4DC' : 'none', borderRadius:
              (props.original.id == undefined || props.original.id == this.state.editedId) ? '2px' : 'none', paddingLeft: '2px'
          }}
          suppressContentEditableWarning
          contentEditable={!((props.original.id == undefined) ? false :
            props.original.id != this.state.editedId) ? "plaintext-only" : false}          type="text" id={"name" + props.index} value={props.original.id == undefined ? "" :
            props.original.name}
        >{props.original.name}</div>)
      },
      {
        Header: <b>URL</b>,
        accessor: 'url',
        Cell: props => (<div
          Align="left" className="input"
          style={{
            paddingLeft: '2px',
            padding: '8px', width: '98%', borderBottom: 'none',
            border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
              '1px solid #D2D4DC' : 'none', borderRadius:
              (props.original.id == undefined || props.original.id == this.state.editedId) ? '2px' : 'none'
          }}
          suppressContentEditableWarning
          contentEditable={!((props.original.id == undefined) ? false :
            props.original.id != this.state.editedId) ? "plaintext-only" : false}
          type="text" id={"url" + props.index} value={props.original.id == undefined ? "" :
            props.original.url}
        >{props.original.url}</div>)
      },
      {
        Header: <b>User Name</b>,
        accessor: 'userName',

        Cell: props => (<div
          Align="left" className="input"
          style={{
            padding: '8px', width: '98%', borderBottom: 'none',
            border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
              '1px solid #D2D4DC' : 'none',
            borderRadius: (props.original.id == undefined || props.original.id == this.state.editedId) ? '2px' : 'none', paddingLeft: '2px'
          }}
          suppressContentEditableWarning
          contentEditable={!((props.original.id == undefined) ? false :
            props.original.id != this.state.editedId) ? "plaintext-only" : false}
          type="text" id={"userName" + props.index} value={props.original.id == undefined ? "" :
            props.original.userName}
        >{props.original.userName}</div>)

      },
      {
        Header: <b>Password</b>,
        accessor: 'password',
        Cell: props => (<div>
          <input
            type={props.original.id == this.state.viewedId ? "text" : "password"}
            style={{
              paddingLeft: '2px', width: '98%', border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
                '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == undefined ||
                  props.original.id == this.state.editedId) ? '2px' : 'none'
            }}
            
            id={"password" + props.index}
            defaultValue={props.original.password}
            disabled={(props.original.id == undefined) ? false :
              props.original.id != this.state.editedId}
          ></input>

          <img className="img-responsive"
            style={{
              display: '-webkit-inline-box', position: 'relative',
              marginLeft: '-34px',
              marginTop: '2px', width: '26px', textAlign: 'right',
              backgroundColor: '#282a65', borderRadius: '5px',
              padding: '2px'
            }}
            src={
              (props.original.id == this.state.viewedId)
                ?
                this.blindEyeSrc
                :
                this.openEyeSrc}
            onClick={(e) => {
              this.viewClickedCell(props, e)

            }}
          />
        </div>)

      },
      {
        Header: <b>Action</b>,
        width: 100,
        Cell: props => {

          return (
            <div id="action">
              {/* edit and delete button */}
              <div style={{ marginTop: '-9px' }}>
                <p>
                  <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                    <img className="img-responsive"
                      style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                      title={(props.original.id == undefined) ||
                        (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                      src={(props.original.id == null) ?
                        this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                          this.editImageSrc : this.saveImageSrc)}
                      onClick={(e) => {
                        (props.original.id == null) ?
                          this.saveBackendApi(props, e) :
                          (props.original.id == this.state.editedId) ?
                            this.updateBackendApi(props, e) :
                            this.editCell(props, e);
                      }}
                    /></button>
                  <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                    <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                      style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                      title="Delete"
                      onClick={() => {
                        (props.original.id) === undefined ?
                          this.fetchBackendApisOfTheProject() :
                          this.setState({
                            hideDeletePopup: true, deletePropIndex: props.index,
                            propsId: props.original.id
                          })
                      }}
                    /></button>
                </p>
              </div>
            </div>
          )
        },
        width: 100
      }
    ]

    return (
      <div style={{ backgroundColor: '#F9F9FB' }}>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: 'center' }}
        />
        <div style={{ display: this.state.successResp ? 'block' : 'none', backgroundColor: '#F9F9FB' }}>
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

          {/* for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />

          <div >
            <div className="row" style={{ marginBottom: '-22px' }}>
              <div className="col-sm-6">

                <h6 className="nav-item" style={{ color: '#282a65', marginLeft: '15px', marginTop: '24px' }}>
                  Define Backend API</h6>

              </div>
              <div className="col-sm-6" Align='right'>
                {/* <button className="btn action-button"
                  id="addMsg" title=" Delete All "
                  onClick={() => {
                    this.setState({
                      hideDeleteAllPopup: true
                    })
                  }}>
                  Delete All
                </button> */}
                <button className="btn action-button "
                  id="addMsg"
                  onClick={this.state.disabled ? this.notifyEmptyFields : this.addRow}
                  title="Add">
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button onClick={this.refreshData} className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png" title="Refresh"></img>
                </button>
              </div>
            </div>

          </div>
          <div style={{ marginTop: "21px", backgroundColor: '#F9F9FB' }}>
            <ReactTable
              data={data}
              columns={columns}
              defaultPageSize={10}
              onPageChange={this.onPageChange}
              page={this.state.pageNum}
              pageSizeOptions={[5, 10, 15]}
              style={{
                backgroundColor: 'white',
                marginRight: '12px', marginLeft: '12px'
              }}
            /></div>
          <br />


          <ToastContainer className="Toast-at-center" />



          {/*Dialog Component For Deletion Confirmation*/}
          <DialogComponent width='400px' animationSettings={this.settings}
            header='Backend API' showCloseIcon={true} buttons={this.buttons}
            ref={dialog => this.dialogInstance = dialog}
            visible={this.state.hideDeletePopup}
            close={this.dialogClose}>
            <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
              content="" />&nbsp;Do you want to delete the API?<br />Note: Press 'Yes' to delete or press 'No' to decline.
          </DialogComponent>

          {/*Dialog Component For  Deletion all Confirmation*/}
          <DialogComponent width='400px' animationSettings={this.settings}
            header='Delete All' showCloseIcon={true} buttons={this.deleteAllButton}
            ref={dialog => this.dialogInstance = dialog}
            visible={this.state.hideDeleteAllPopup} close={this.dialogClose}>
            <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
              content="" />&nbsp;Do you want to delete all the APIs?<br />Note: Press 'Yes' to delete or press 'No' to decline.
          </DialogComponent>
          {/*Dialog Component For  Incorrect Password*/}

          <DialogComponent width='400px' animationSettings={this.settings}
            header='Incorrect Password' showCloseIcon={true} buttons={this.incorrectPasswordButtons}
            ref={dialog => this.dialogInstance = dialog}
            visible={this.state.hideIncorrectPassword} close={this.IncorrectPassworddialogClose}>
            Please type "Delete"
          </DialogComponent>
          {/*Dialog Component For  Delete input confirmation*/}


          <DialogComponent width='400px' animationSettings={this.settings}
            header='Delete Confirmation' showCloseIcon={true} buttons={this.textAreaConfir}
            ref={dialog => this.dialogInstance = dialog}
            visible={this.state.hideTextAreaPopup} close={this.DeletedialogClose}>
            Please type "Delete" for confirmation<input type="text" id="deleteInputFromUser" />
          </DialogComponent>

        </div>
      </div>
    );
  }
}
export default BackendApiView;



// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/BackendApiView.js